import { render, staticRenderFns } from "./ProductAssetsTab.vue?vue&type=template&id=5dfb4a44"
import script from "./ProductAssetsTab.vue?vue&type=script&lang=js"
export * from "./ProductAssetsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports